import {IItemContent} from "@connox/typescript-library";
import React, {Suspense} from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import ProductCard from "./ProductSeriesCard/ProductCard";

const breakpointTablet = 480;
const breakpointTabletLarge = 1120;

const HeaderContent = styled.p`
  display: block;
  white-space: normal;
  padding: 0 1rem;
  @media only screen and (min-width: ${breakpointTabletLarge}px) {
    padding: 0;
  }
`;

const SliderDiv = styled.div`
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  font-size: 1rem;
  padding: 0 0 1rem 0;
  margin-bottom: 2rem;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-wrap: nowrap;
  scroll-snap-type: x mandatory;
  @media only screen and (min-width: ${breakpointTablet}px) {
    width: 100%;
    white-space: normal;
    padding: 0;
    display: block;
  }
`;

const ContentDiv = styled.div`
  margin-left: 0;
  margin-right: 0;
`;

interface IParentCategoryProps {
  name: string;
  url: string;
  products: IItemContent[];
}

const ExploreRelatedSeries: React.FC<IParentCategoryProps> = (props) => {
  const {name, products, url} = props;
  const parents = products.map((card: IItemContent, index: number) => {
    return <ProductCard key={index} {...card} />;
  });
  const {t} = useTranslation();

  return (
    <Suspense fallback={null}>
      <ContentDiv>
        <HeaderContent as="h2">{t("{{name}}: Entdecken Sie die Serie zum Produkt.", {name})}</HeaderContent>
        <HeaderContent>
          <a href={url}>{t("Alle Produkte von {{name}}", {name})}</a>
        </HeaderContent>
        <SliderDiv>{parents}</SliderDiv>
      </ContentDiv>
    </Suspense>
  );
};

export default ExploreRelatedSeries;
